<template>
  <nav class="bg-[#1F1F1F] text-white">
    <!-- Mobil (üstte yatay) -->
    <div
      class="md:hidden flex justify-around px-4 py-3 border-b border-gray-800 shadow"
    >
      <NuxtLink
        to="/dashboard"
        class="text-sm"
        exact-active-class="text-teal-400 font-bold"
      >
        📊
      </NuxtLink>
      <NuxtLink
        to="/dashboard/profile"
        class="text-sm"
        exact-active-class="text-teal-400 font-bold"
      >
        👤
      </NuxtLink>
      <NuxtLink
        to="/dashboard/subscription"
        class="text-sm"
        exact-active-class="text-teal-400 font-bold"
      >
        ⭐
      </NuxtLink>
      <NuxtLink
        to="/dashboard/payment"
        class="text-sm"
        exact-active-class="text-teal-400 font-bold"
      >
        💳
      </NuxtLink>
    </div>

    <!-- Desktop (sol yanda dikey) -->
    <aside
      class="hidden md:block w-64 shadow-lg p-6 space-y-4 border-r border-t border-gray-200 min-h-screen"
    >
      <NuxtLink
        to="/dashboard"
        class="block font-semibold rounded px-2 py-1 hover:bg-gray-700 transition"
        exact-active-class="bg-teal-100 text-teal-700 font-bold text-lg"
      >
        📊 {{ t("dashboard.menu.dashboard") }}
      </NuxtLink>

      <NuxtLink
        to="/dashboard/profile"
        class="block rounded px-4 py-1 hover:bg-gray-700 transition"
        exact-active-class="bg-teal-100 text-teal-700 font-bold text-lg"
      >
        👤 {{ t("dashboard.menu.profile") }}
      </NuxtLink>

      <NuxtLink
        to="/dashboard/subscription"
        class="block rounded px-2 py-1 hover:bg-gray-700 transition"
        exact-active-class="bg-teal-100 text-teal-700 font-bold text-lg"
      >
        ⭐ {{ t("dashboard.menu.subscription") }}
      </NuxtLink>

      <NuxtLink
        to="/dashboard/payment"
        class="block rounded px-2 py-1 hover:bg-gray-700 transition"
        exact-active-class="bg-teal-100 text-teal-700 font-bold text-lg"
      >
        💳 {{ t("dashboard.menu.payment") }}
      </NuxtLink>
    </aside>
  </nav>
</template>

<script setup>
import { useI18n } from "#imports";

const { t } = useI18n();
defineOptions({ name: "DashboardSidebar" });
</script>
